import { createAction } from 'typesafe-actions';

export const changeCoworkingTitleAction = createAction('filters/CoworkingTitleChanged')<{
  id: number;
  name: string;
}>();

export const setCoworkingTitlesAction = createAction('filters/setCoworkingTitle')<{ id: number; name: string }[]>();
